<p-selectButton
  optionLabel="icon"
  optionValue="value"
  [(ngModel)]="selectedMode"
  [options]="options"
  [unselectable]="false"
>
  <ng-template #item let-item>
    <i [class]="item.icon" [pTooltip]="item.tooltip"></i>
  </ng-template>
</p-selectButton>
